import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Typography } from './Typography';

export interface TabProps {
	value: string;
	onValueChange: (value: string) => void;
	options: { name: string; displayName?: string }[];
}


export const Tab = ({ value, onValueChange, options }: TabProps) => {
	return (
		<Tabs
			value={value || ''}
			onValueChange={onValueChange}
			className="w-full"
		>
			<TabsList className="w-full flex rounded-2xl p-1 gap-1 border border-tablz-med-gray-4 bg-tablz-med-gray-1 justify-between h-fit">
				{options.map((option) => (
					<TabsTrigger
						key={option.name}
						value={option.name}
						className={`py-3 px-4 rounded-2xl hover:bg-tablz-med-gray-6 ${value === option.name && 'bg-tablz-med-gray-6'} grow`}
						aria-label={`Select ${option.displayName || option.name} tab`}
					>
						<Typography
							className="text-tablz-text-gray-2 font-poppins text-lg font-semibold capitalize"
						>
							{option.displayName || option.name}
						</Typography>
					</TabsTrigger>
				))}
			</TabsList>
		</Tabs>
	);
};
